namespace Areas.Budget.Linked {
    "use strict";

    export function relinkSelected() {
        const linkedGrid = $("#BudgetLinkedGrid").dxDataGrid("instance");
        const rowsSelected = linkedGrid.getSelectedRowsData();
        if (rowsSelected[0] == null) {
            DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
        } else {
            let subCode = rowsSelected[0].ucopSubCodeLk;
            //check that all selected rows have the same ucopsubcodelk
            for (var i = 0; i < rowsSelected.length; i++) {
                if (rowsSelected[i].ucopSubCodeLk != subCode) {
                    console.log(rowsSelected[i]);
                    console.log(subCode);
                    DevExpress.ui.notify("All Selected Records must be for the same Sub", "warning", 4000)
                    return;
                }
            }

            let accountId = linkedGrid.option("AccountId");
            let budgetId = linkedGrid.option("BudgetId");
            const parameters = { accountId: accountId, sub: subCode, budgetId: budgetId };
            const relinkSameSubDialog =
                new Areas.Dialogs.BudgetAccountCategory.RelinkSameSubDialog(RelinkDialogClosing(), parameters);
        }
    }

    //select Link Category
    function RelinkDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const linkedGrid = $("#BudgetLinkedGrid").dxDataGrid("instance");
            const budgetItemLinkIds = linkedGrid.getSelectedRowKeys().join(',');


            //for each selected record relink/update BudgetItemCategoryId in BudgetItemLink records
            let newBudgetAccountCategoryId: number = 0;
            newBudgetAccountCategoryId = data.budgetAccountCategoryId;

            let url = `/Budget/Linked/RelinkItems/${budgetItemLinkIds}/${newBudgetAccountCategoryId}`;


            const method = "POST";

            sendRequest(url,
                "",
                method,
                (data) => {
                    Areas.reloadPage();
                });

        }
    }


    export function reclassifySelected() {
        const linkedGrid = $("#BudgetLinkedGrid").dxDataGrid("instance");
        const rowsSelected = linkedGrid.getSelectedRowsData();
        let accountId = linkedGrid.option("AccountId");


        if (rowsSelected[0] == null || rowsSelected.length > 1) {
            DevExpress.ui.notify("Please make a selection first ... one row only!", "warning", 2000);
        } else {
            if (rowsSelected[0].isLocked) {
                DevExpress.ui.notify("This record is locked ... not editable", "warning", 2000);
                return;
            }
            else {

                const parameters = {
                    data: rowsSelected[0],
                    accountId: accountId
                };
                const budgetAccountCategoryLinkDialog =
                    new Areas.Dialogs.BudgetAccountCategory.ReclassifyLinkDialog(reclassifyLinkDialogClosing(), parameters);
            }
        }
    }

    function reclassifyLinkDialogClosing() {

        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) {

              
                sendRequest("/Budget/Linked/ReclassifyCancel",
                    data,
                    "POST");
            }
            else {
              
                sendRequest("/Budget/Linked/ReclassifyItem",
                    data,
                    "POST",
                    (data) => {
                    Areas.reloadPage();
                });
            }

           

        }
    }

    export function changePCategorylinkItems() {
        const linkedGrid = $("#BudgetLinkedGrid").dxDataGrid("instance");
        const rowsSelected = linkedGrid.getSelectedRowsData();
        if (rowsSelected[0] == null) {
            DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
        } else {
            let accountId = linkedGrid.option("AccountId");
            let budgetId = linkedGrid.option("BudgetId");
            const parameters = { accountId: accountId, budgetId: budgetId };
            const changePCategoryDialog =
                new Areas.Dialogs.ChangePCategory.ChangePCategoryDialog(changePCategoryDialogClosing(), parameters);
        }
    }

    function changePCategoryDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const linkedGrid = $("#BudgetLinkedGrid").dxDataGrid("instance");
            const budgetItemLinkIds = linkedGrid.getSelectedRowKeys().join(',');
            data.dataIds = budgetItemLinkIds;

            const newData = JSON.stringify(data);

            let url = "/Budget/Linked/ChangePCategory/";
            const method = "POST";

            sendRequest(url,
                newData,
                method,
                (_) => {
                    Areas.reloadPage();
                });

        }
    }

}
